export const administrative_ticket_stat = {
  id: "administratif_ticket_stat-1",
  default: true,
  roles: [],

  title: "Stat ticket",
  type: "listStat",
  conf: {
    element: "administrativeTicket",
    stats: [
      {
        title:"Qté demande accès utilisateur",
        stat:"quantity",
        attribute:"id",
        filters:{
          state:{
            _parameterType:"value",
            _title:"",
            value:[
              {
                value:"new",
                label:"Nouveau"
              },
              {
                value:"waiting",
                label:"En attente"
              },
              {
                value:"in_progress",
                label:"En cours de progrès"
              }
            ]
          },
          requestType:[
            {
              id:12,
              name:"Demande de modifications d'accès utilisateur"
            }
          ],
        }
      },
      {
        title:"Qté demande sur facturation",
        stat:"quantity",
        attribute:"id",
        filters:{
          state:{
            _parameterType:"value",
            _title:"",
            value:[
              {
                value:"new",
                label:"Nouveau"
              },
              {
                value:"waiting",
                label:"En attente"
              },
              {
                value:"in_progress",
                label:"En cours de progrès"
              }
            ]
          },
          requestType:[
            {
              id:13,
              name:"Demande sur facturation"
            }
          ],
        }
      },
      {
        title:"Qté demande administrative",
        stat:"quantity",
        attribute:"id",
        filters:{
          state:{
            _parameterType:"value",
            _title:"",
            value:[
              {
                value:"new",
                label:"Nouveau"
              },
              {
                value:"waiting",
                label:"En attente"
              },
              {
                value:"in_progress",
                label:"En cours de progrès"
              }
            ]
          },
          requestType:[
            {
              id:14,
              name:"Demande administrative"
            }
          ],
        }
      },
    ]
  },
  column: 2,
  row: 2
}
